import type { Field } from '@/api/types/crm/crm.types'

/** Системные UTM-поля лида (редактируются во вкладке «UTM метки»). */
export const UTM_LEAD_FIELD_UNIQUE_NAMES = [
  'UTM_SOURCE',
  'UTM_MEDIUM',
  'UTM_CAMPAIGN',
  'UTM_CONTENT',
  'UTM_TERM',
] as const

export type UtmLeadFieldUniqueName = (typeof UTM_LEAD_FIELD_UNIQUE_NAMES)[number]

/** Подсказки при наведении на поле во вкладке «UTM метки». */
export const UTM_LEAD_FIELD_TOOLTIPS: Record<UtmLeadFieldUniqueName, string> = {
  UTM_SOURCE:
    'UTM_SOURCE. Источник трафика — откуда пришёл посетитель: поисковик, соцсеть, рассылка, партнёрский сайт. Примеры: google, yandex, vk, newsletter.',
  UTM_MEDIUM:
    'UTM_MEDIUM. Тип канала — как именно пришёл трафик: контекстная реклама, email, органика, баннер. Примеры: cpc, email, organic, banner.',
  UTM_CAMPAIGN:
    'UTM_CAMPAIGN. Название рекламной кампании или акции — помогает отличить один запуск от другого. Пример: spring_sale_2025.',
  UTM_CONTENT:
    'UTM_CONTENT. Вариант объявления или ссылки — для A/B-тестов: какой баннер, кнопка или текст сработал. Примеры: blue_button, text_link.',
  UTM_TERM:
    'UTM_TERM. Ключевое слово или фраза из контекстной рекламы. Обычно заполняется для платного поиска. Пример: курсы английского.',
}

const UTM_LEAD_FIELD_UNIQUE_NAMES_SET = new Set<string>(
  UTM_LEAD_FIELD_UNIQUE_NAMES,
)

export const getUtmLeadFieldTooltip = (
  uniqueName: string,
): string | undefined => {
  if (!UTM_LEAD_FIELD_UNIQUE_NAMES_SET.has(uniqueName)) return undefined
  return UTM_LEAD_FIELD_TOOLTIPS[uniqueName as UtmLeadFieldUniqueName]
}

export const isUtmLeadField = (field: Pick<Field, 'unique_name'>): boolean =>
  UTM_LEAD_FIELD_UNIQUE_NAMES_SET.has(field.unique_name)

export const filterUtmLeadFields = (fields: Field[]): Field[] =>
  fields
    .filter((field) => field.is_active && isUtmLeadField(field))
    .sort((a, b) => a.sorting - b.sorting)
